module.exports = new __parcel__URL__("ww-title-core-elements.899e1aca.jpg").toString();